// Canonical background-job status vocabulary — shared across all consumers.
// All background agent jobs (approval/matching/compliance/schema/takeoff) use the
// same canonical tokens: pending | running | done | failed | cancelled.
// Document upload status (document_processing_status) keeps its own
// pending/processing/completed/failed and is polled separately — it is not included here.

export const RUNNING_STATUSES = new Set(["pending", "running"]);
export const FAILURE_STATUSES = new Set(["failed"]);
export const DONE_STATUSES = new Set(["done"]);
export const CANCELLED_STATUSES = new Set(["cancelled"]);
// Takeoff-only: Phase 1 (legend extraction) finished and is deliberately
// paused, waiting on the user to review/confirm the legend before Phase 2
// (the expensive per-wall CV+VLM classification) starts — not running (no
// worker is actively processing it) and not terminal (Phase 2 hasn't
// happened yet). See construction.py's run_legend_phase_pipeline.
export const AWAITING_INPUT_STATUSES = new Set(["awaiting_legend_approval"]);

/** True while the job is still in flight (queued or running). */
export const isRunningStatus = (status) => RUNNING_STATUSES.has(status);

/** True when the job ended in failure. */
export const isFailureStatus = (status) => FAILURE_STATUSES.has(status);

/** True when the job finished successfully. */
export const isDoneStatus = (status) => DONE_STATUSES.has(status);

/** True when the job was stopped by the user (not a failure). */
export const isCancelledStatus = (status) => CANCELLED_STATUSES.has(status);

/** True when the job is paused waiting on user input (not running, not terminal). */
export const isAwaitingInputStatus = (status) => AWAITING_INPUT_STATUSES.has(status);

/** True when the job has reached any terminal state (success, failure, or cancelled). */
export const isTerminalStatus = (status) =>
  isDoneStatus(status) || isFailureStatus(status) || isCancelledStatus(status);
